export const TeamSchema = function (team) {



}


// WEBPACK FOOTER //
// ./src/schemas/team.js